import React from 'react';
import { Link } from 'react-router-dom';
import profileService from '../../services/profileService';
import sessionService from '../../services/sessionService';

class Login extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            username: '',
            password: '',
            error: '',
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.options = {
            autoClose: 3000,
            hideProgressBar: true,
        };
    }

    handleChange = event => {
        this.setState({
            [event.target.name]: event.target.value,
            error: null
        });
    }

    handleSubmit = event => {
        event.preventDefault();
        const { username, password } = this.state;

        if (this.validateForm()) {
            profileService.login(username, password)
                .then(response => {
                    sessionService.create(response);
                    if (sessionService.isAuth()) {
                        this.props.history.push("/dashboard/charts");
                    }
                }).catch(error => {
                    this.setState({ error: "Error: Wrong username or password!" })
                });
        } else {
            this.setState({ error: "All field are required!" })
        }

    }

    validateForm() {
        return this.state.username.length > 3 && this.state.password.length > 3;
    }

    render() {
        const { username, password, error } = this.state;
        return (
            <div className="auth-page-container container-fluid">
                <div className="auth-frame jumbotron">
                    <div className="auth-img-box ">
                        <img
                            className="auth-logo"
                            src='/assets/images/logo.png'
                            alt="AirTouch logo"
                        />
                    </div>
                    <form onSubmit={this.handleSubmit} className="text-left">
                        <div className="form-group">
                            <label htmlFor="username" className="text-white">Username:</label>
                            <input id='username' className="form-control" type="text" name="username" value={username} onChange={this.handleChange} />
                        </div>
                        <div className="form-group">
                            <label htmlFor="password" className="text-white">Password:</label>
                            <input id='password' className="form-control" type="password" name="password" value={password} onChange={this.handleChange} />
                        </div>
                        {error &&
                            <div className={'alert alert-danger'}>{error}</div>
                        }
                        <div className="text-right">
                            <button type="submit" className="btn btn-lightblue">Login</button>
                        </div>


                    </form>
                    <div className="auth-footer">
                        <div>
                            <span>  Don't have an account yet?</span> <Link to="/register" >Sign up!</Link>
                        </div>
                        <div>
                            <span>Forgot password?</span> <Link to="/forgot">Click here!</Link>

                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Login;


// WEBPACK FOOTER //
// ./src/components/loginComponent/login.js